import React__default from 'react';
import { Text } from '@grandvisionhq/elements';

const FramesBundleContentDescription = ({ description  })=>/*#__PURE__*/ React__default.createElement(Text, null, description)
;

export { FramesBundleContentDescription };
//# sourceMappingURL=FramesBundleContentDescription.js.map
